import React, { useState, useEffect } from 'react';
import BannerInicio from '../components/Inicio/BannerInicio';
import CardServicio from '../components/Servicios/CardServicio';
import clienteAxios from '../helpers/axios.helper';

function Servicios() {
  const [categoriaServicios, setCategoriaServicios] = useState([]); // Estado para almacenar los servicios
  const [error, setError] = useState(null); // Estado para manejar errores
  const banner = "https://agroh.info/imagenes/extras/bannerServicio.jpg";

  // Función para obtener los servicios desde la API usando Axios
  const cargarCategoriasServicios = async () => {
    try {
      const respuesta = await clienteAxios.get("/categorias_servicios");
      setCategoriaServicios(respuesta.data);
    } catch (error) {
      alert("Hubo un problema al cargar las categorías. Por favor, intenta más tarde.");
    }
  };

  // Llamar a la API cuando el componente se monte
  useEffect(() => {
    cargarCategoriasServicios();
  }, []); // El array vacío significa que solo se ejecuta una vez, cuando el componente se monta

  if (error) {
    return <div>Error: {error}</div>; // Muestra un mensaje de error si la API falla
  }

  return (
    <div className="min-w-screen flex flex-col items-center bg-GrisClaro">
      {/* Banner */}
      <BannerInicio img={banner} texto={"Transformamos tu negocio con soluciones integrales: ofrecemos asesoramiento experto, instalación de software especializado, y la implementación de dispositivos y herramientas tecnológicas de vanguardia."} />

      {/* Sección de servicios */}
      <div className="min-h-screen w-10/12 p-8">
        {categoriaServicios.length === 0 ? (
          <div>Cargando servicios...</div> // Mensaje de carga mientras se obtienen los datos
        ) : (
          categoriaServicios.map(servicio => (
            <CardServicio
              key={servicio.id}
              id={servicio.id}
              titulo={servicio.titulo}
              descripcion={servicio.descripcion}
              categoriaServicios={categoriaServicios}
              img={servicio.img}
            />
          ))
        )}
      </div>
    </div>
  );
}

export default Servicios;
